import { BaseModel } from './base';
import { Opponent } from './opponent';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export interface AccidentSummary {
    trans: { accident_abroad: string };
    accident_abroad: boolean;
    opponent: Opponent;
}

export class Accident extends BaseModel
                      implements AccidentSummary {

    public clerk: string;
    public comment: string;
    public description: string;
    public opponent: Opponent;
    public police_department: string;
    public police_reference_number: string;
    public accident_abroad: boolean;

    public animal: boolean;
    public collision: boolean;
    public driveways: boolean;
    public fire_damage: boolean;
    public glass_damage: boolean;
    public lane_change: boolean;
    public miscellaneous: boolean;
    public parking: boolean;
    public right_before_left: boolean;
    public storm_hail_damage: boolean;
    public theft: boolean;
    public total_theft: boolean;
    public vehicle_breakdown: boolean;
    

    public readonly trans = {
        accident_abroad: marker('accident.accident_abroad'),
        clerk: marker('accident.clerk'),
        comment: marker('accident.comment'),
        description: marker('accident.description'),
        police_department: marker('accident.police_department'),
        police_reference_number: marker('accident.police_reference_number'),
        animal: marker('accident.type.animal'),
        collision: marker('accident.type.collision'),
        driveways: marker('accident.type.driveways'),
        fire_damage: marker('accident.type.fire_damage'),
        glass_damage: marker('accident.type.glass_damage'),
        lane_change: marker('accident.type.lane_change'),
        miscellaneous: marker('accident.type.miscellaneous'),
        parking: marker('accident.type.parking'),
        right_before_left: marker('accident.type.right_before_left'),
        storm_hail_damage: marker('accident.type.storm_hail_damage'),
        theft: marker('accident.type.theft'),
        total_theft: marker('accident.type.total_theft'),
        vehicle_breakdown: marker('accident.type.vehicle_breakdown')
    };

    constructor(json?: any) {
        super(json);
    }
 
    protected setObjectMappings(json: any): any {
        return Object.assign(super.setObjectMappings(json), {
            opponent: new Opponent(json && json.opponent)
        });
    }
}
